<icc-list
[items]="items"
(select)="selectItem($event)"
itemTemplate="itemImgTitle"
[selected]="selectedItemId"
></icc-list>
